import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'react-bootstrap';
import { components } from 'react-select';
import Select from 'react-select';

import NewLeadModal from './sale_buyer/new_lead_modal';
import ProjectLeadSearch from './sale_buyer/project_lead_search';
import { horizontalFormStyles } from 'helpers/react_select_helpers';
import { get } from 'helpers/api';

const Menu = props => (
  <components.Menu {...props} className="menu-list">
    {props.children}
    <div className="text-create text-center clickable py-3" onClick={props.selectProps.onCreateClick}>
      <strong>+ Create new lead</strong>
    </div>
  </components.Menu>
);

Menu.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.shape({
    onCreateClick: PropTypes.func.isRequired
  })
};

export default function SaleBuyer({
  buyerRequired,
  defaultSelectedBuyer,
  defaultSelectedReferralSourceId,
  formNameRoot,
  projectId,
  referralSources,
  required,
  statusInputName
}) {
  function showBuyerInput(statusInputName) {
    return document.querySelector(`input[name="${statusInputName}"]:checked`).value === '3';
  }

  const [showNewLead, setShowNewLead] = useState(false);
  const [show, setShow] = useState(showBuyerInput(statusInputName));
  const [selectedBuyer, setSelectedBuyer] = useState(defaultSelectedBuyer);
  const [selectedReferralSourceId, setSelectedReferralSourceId] = useState(defaultSelectedReferralSourceId);

  React.useEffect(() => {
    const statusChangeHandler = (e) => {
      if (e.target.name === statusInputName) {
        setShow(showBuyerInput(statusInputName));
      }
    };

    window.addEventListener('change', statusChangeHandler);
    return () => window.removeEventListener('change', statusChangeHandler);
  }, []);

  React.useEffect(() => {
    if (selectedBuyer && selectedBuyer !== defaultSelectedBuyer) {
      get(`/projects/${projectId}/leads/${selectedBuyer.id}`).then((lead) => {
        if (lead.referralSource) setSelectedReferralSourceId(lead.referralSource);
      });
    }
  }, [selectedBuyer?.id]);

  function setNewLead(id, name) {
    setSelectedBuyer({ id, name });
  }

  return (
    <div className={show ? '' : 'd-none'}>
      <FormGroup className={buyerRequired ? 'required' : ''}>
        <div className="form-group-stretch">
          <label className="control-label">Buyer</label>
          <div className="w-100">
            <input
              id="property_sale_listing_buyer_lead_id"
              name={`${formNameRoot}[buyer_lead_id]`}
              type="hidden"
              value={selectedBuyer?.id || ''}
            />
            <ProjectLeadSearch
              projectId={projectId}
              selectedLead={selectedBuyer}
              onLeadSelected={setSelectedBuyer}
              onNewLeadSelected={() => setShowNewLead(true)}
            />
          </div>
        </div>
      </FormGroup>
      <FormGroup className={required ? 'required' : ''}>
        <div className="form-group-stretch">
          <label className="control-label">
            Referral Source
            {required && (<abbr title="required">*</abbr>)}
          </label>
          <div className="w-100">
            <input
              id="property_sale_listing_buyer_referral_source_id"
              name={`${formNameRoot}[buyer_referral_source_id]`}
              type="hidden"
              value={selectedReferralSourceId || ''}
            />
            <Select
              isClearable={true}
              name="referralSourceSelect"
              options={referralSources}
              styles={horizontalFormStyles}
              value={referralSources.find(referralSource => referralSource.value === selectedReferralSourceId)}
              onChange={referralSource => setSelectedReferralSourceId(referralSource?.value)}
            />
          </div>
        </div>
      </FormGroup>

      <NewLeadModal
        projectId={projectId}
        show={showNewLead}
        onHide={() => setShowNewLead(false)}
        onSave={setNewLead}
      />
    </div>
  );
}

SaleBuyer.propTypes = {
  buyerRequired: PropTypes.bool.isRequired,
  defaultSelectedBuyer: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  defaultSelectedReferralSourceId: PropTypes.number,
  formNameRoot: PropTypes.string.isRequired,
  projectId: PropTypes.number,
  referralSources: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  required: PropTypes.bool.isRequired,
  statusInputName: PropTypes.string.isRequired
};
